import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {filterUser_template} from "./filterUser_template";
import {filterArticle_template} from "./filterArticle_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";


declare var ko: any;

export class transactionsVerificationList_template extends vnTemplate {

    protected pagination: pagination_template;
    protected dateFilter: filterDate_template;
    protected validationsList: validationsList_template;
    protected filterUser: filterUser_template;
    protected filterArticle: filterArticle_template;
    protected filterContentType: multipleSelector_template;
    protected filterKeywords: filterSimple_template;
    protected paymentCategoryFilter : multipleSelector_template;
    protected zeroColumnsFilter : multipleSelector_template;
    protected rolesFilter : filterDropdown_template;

    protected resultsInfos: resultsInfo_template;


    protected getTemplateHtml(): string {
        return `

            <div class="sub-header w-justify">

                <div class=" w-justify">
                    <div class="w-left">
                        ${ this.filterContentType.getHtmlBuild() }
                        ${ this.zeroColumnsFilter.getHtmlBuild() }
                        ${ this.paymentCategoryFilter.getHtmlBuild() }
                        ${ this.filterUser.getHtmlBuild() }
                        <div>
                            <label for="idRole" class="form-label form-label-box">Roles</label>
                            ${ this.rolesFilter.getHtmlBuild() }
                        </div>
                        ${ this.dateFilter.getHtmlBuild() }
                    </div>
                </div>

            </div>
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-contentType"></div>
                    <div id="selected-payment_categories"></div>
                    <div id="selected-author"></div>
                </div>
            </div>
            <div class="list-header w-justify" >
                <div class="w-left" >
                    <button class="btn secondary icon i-next" type="button" data-bind="css: { 'is-disable': editedFieldCount() == 0 }, event: { click : onApplyChanges }, text: 'Apply ' + editedFieldCount()  + ' Changes'">Apply</button>

                    <div class="form-group" style="margin-right: 0;">
                        <label class="form-label above" style="margin-right: 10px;">PPS Rate</label>
                        <input class="input-text" type="text" data-bind="textInput: ppsRate, event: { keyup: onCalculatePayPerSession }, valueUpdate : 'afterkeydown'" placeholder="PPS Rate">
                    </div>
                    <div class="form-group" style="margin-right: 0;">
                        <label class="form-label above">Min PPS Payout</label>
                        <input class="input-text" type="text" data-bind="textInput: minPayout, event: { keyup: onCalculatePayPerSession }, valueUpdate : 'afterkeydown'" placeholder="Min PPS Payout">
                    </div>
                    <div class="form-group" style="margin-right: 0;">
                        <label class="form-label above">Max PPS Payout</label>
                        <input class="input-text" type="text" data-bind="textInput: maxPpsPayout, event: { keyup: onCalculatePayPerSession }, valueUpdate : 'afterkeydown'" placeholder="Max PPS Payout">
                    </div>

                    <div class="form-group row" style="margin: 0;display: flex;flex-direction:column;align-items: flex-start;">
                        <div class="form-check-inline width-auto">
                            <input type="radio" name="sessionAggregate" id="us_sessions" value="us" data-bind="checked: sessionAggregate, event: {change : onClickSessionsAggregate}"/>
                            <label  class="form-label nowrap" for="us_sessions" style="margin-bottom: 0;">US Sessions</label>
                        </div>
                        <div class="form-check-inline width-auto">
                            <input type="radio" name="sessionAggregate" id="all_sessions" value="all" data-bind="checked: sessionAggregate, event: {change : onClickSessionsAggregate}"/>
                            <label class="form-label nowrap" for="all_sessions">All Sessions</label>
                        </div>
                    </div>
                </div>
                <div class="w-center">
                    ` + this.filterKeywords.getHtmlBuild() + `
                </div>
                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>

            <div class="w-list-results"  data-bind="css: { loading: isLoading }">

                <table class="list-results">
                ` + this.resultsInfos.getHtmlBuild() + `
                    <thead>
                        <tr class="list-grand-total">
                            <th class="align-left" colspan="6"><span>All pages totals</span></th>
                            <th><span data-bind="text: Number(totalSessions()).toLocaleString('en-US')"></span></th>
                            <th><span data-bind="text: Number(totalUsSessions()).toLocaleString('en-US')"></span></th>
                            <th><span data-bind="text: Number(totalCommission()).toLocaleString('en-US')"></span></th>
                            <th><span data-bind="text: Number(totalPerformance()).toLocaleString('en-US')"></span></th>
                            <th class="total"><span data-bind="text: Number(sessionAggregate() == 'us' ? totalPpsUsCalc() : totalPpsAllCalc()).toLocaleString('en-US')"></span></th>
                            <th class="total"><span data-bind="text: Number(totalAmount()).toLocaleString('en-US')"></span></th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">Article ID</span></th>
                            <th style="min-width: 22rem;'><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Article Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'user') }, css: { 'list-sort-desc': orderByAndDirection()=='user_DESC', 'list-sort-asc': orderByAndDirection()=='user_ASC' }">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'contentType') }, css: { 'list-sort-desc': orderByAndDirection()=='contentType_DESC', 'list-sort-asc': orderByAndDirection()=='contentType_ASC' }">Content Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'paymentCategory') }, css: { 'list-sort-desc': orderByAndDirection()=='paymentCategory_DESC', 'list-sort-asc': orderByAndDirection()=='paymentCategory_ASC' }">Payment Category</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sessions') }, css: { 'list-sort-desc': orderByAndDirection()=='sessions_DESC', 'list-sort-asc': orderByAndDirection()=='sessions_ASC' }">L15D Total Sessions</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'usSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='usSessions_DESC', 'list-sort-asc': orderByAndDirection()=='usSessions_ASC' }">L15D US Sessions</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalCommission') }, css: { 'list-sort-desc': orderByAndDirection()=='totalCommission_DESC', 'list-sort-asc': orderByAndDirection()=='totalCommission_ASC' }">Article Commission</span></th>
                            <th class="align-right"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalPerformance') }, css: { 'list-sort-desc': orderByAndDirection()=='totalPerformance_DESC', 'list-sort-asc': orderByAndDirection()=='totalPerformance_ASC' }">Article Performance</span></th>
                            <th class="align-right total"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ppsCalc') }, css: { 'list-sort-desc': orderByAndDirection()=='ppsCalc_DESC', 'list-sort-asc': orderByAndDirection()=='ppsCalc_ASC' }">Pay Per Session Calc</span></th>
                            <th class="align-right total"><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalAmount') }, css: { 'list-sort-desc': orderByAndDirection()=='totalAmount_DESC', 'list-sort-asc': orderByAndDirection()=='totalAmount_ASC' }">Total Amount</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: data">
                        <tr>
                            <td></td>
                            <td><span data-bind="text: id"></span></td>
                            <td><span data-bind="text: title"></span></td>
                            <td><span data-bind="text: user"></span></td>
                            <td><span data-bind="text: contentType"></span></td>

                            <td><span data-bind="text: paymentCategory"></span></td>
                            <td class="align-right"><span data-bind="text: sessions"></span></td>
                            <td class="align-right"><span data-bind="text: usSessions"></span></td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalCommissionEdited() }" ></span>
                                    <input class="input-text" type="text" tabindex="0" data-bind="disable : disableInput(), textInput: totalCommission, css: {'read-only' : totalCommission() > 0 && !totalCommissionEdited()},  event: { keyup: $parent.onEditAmount.bind($data, 'commission')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>
                            <td class="align-right">
                                <div class="w-cell">
                                    <span class="apply-icon icon i-next " data-bind="css: { 'is-edited': totalPerformanceEdited() }"></span>
                                    <input class="input-text" type="text" tabindex="2" data-bind="disable : disableInput(), textInput: totalPerformance,css: {'read-only' : totalPerformance() > 0 && !totalPerformanceEdited()}, event: { keyup: $parent.onEditAmount.bind($data, 'performance')}, valueUpdate : 'afterkeydown'">
                                </div>
                            </td>
                            <td class="align-right total">
                                <span data-bind="text: ppsCalc"></span>
                                <button class="icon i-info btn-form" data-bind="event: { click: $parent.onCopyPpsCalcToPerformance.bind($data) }">Copy</button>
                            </td>
                            <td class="align-right total"><span data-bind="text: totalAmount"></span></td>
                        </tr>
                    </tbody>
                </table>

            </div>
            `;
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        let currentDate = new Date();
        this.dateFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().selectedFilter("range");
        this.dateFilter.setRange("-15d", "15d");

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.filterUser = new filterUser_template("filterUser", this.getTemplateViewModel(), this.caller);
        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);

        this.filterContentType = new multipleSelector_template("filterContentType", this.getTemplateViewModel(), this.caller);
        this.filterContentType.setLabel("content types");
        this.filterContentType.setFilterContainerClass('margin-neg');
        this.filterContentType.setTagContainerId('selected-contentType');
        this.filterContentType.setTagContainerCaption('Selected content type:');


        this.zeroColumnsFilter = new multipleSelector_template("zeroColumnsFilter", this.getTemplateViewModel(), this.caller);
        this.zeroColumnsFilter.setLabel("Zero Columns");
        this.zeroColumnsFilter.setFilterContainerClass('margin-neg');
        this.zeroColumnsFilter.setTagContainerId('selected-zero-columns');
        this.zeroColumnsFilter.setTagContainerCaption('Selected Zero Column:');


        this.filterKeywords = new filterSimple_template("filterKeywords", this.getTemplateViewModel(), this.caller);
        this.resultsInfos = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);

        this.paymentCategoryFilter = new multipleSelector_template("paymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("Payment category");
        this.paymentCategoryFilter.setFilterContainerClass('margin-neg');
        this.paymentCategoryFilter.setTagContainerId('selected-payment_categories');
        this.paymentCategoryFilter.setTagContainerCaption('Selected payment categories:');

        this.rolesFilter = new filterDropdown_template("rolesFilter", this.getTemplateViewModel(), this.caller);
        this.rolesFilter.setOptions([{ id: 6, name: "Writer" }, { id: 4, name: "Editor" }]);
        this.rolesFilter.getTemplateViewModel().selectedOption(6);
    }

    protected getTemplateName(): string {
        return "transactionsVerificationList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            orderBy: ko.observable("totalAmount"),
            orderByAndDirection: ko.observable("totalAmount_ASC"),
            orderByDirection: ko.observable("ASC"),
            editedFieldCount: ko.observable(0),
            data: ko.observableArray([]),
            isLoading: ko.observable(0),
            viewDaysSpan: ko.observable(15),
            ppsRate: ko.observable(5),
            minPayout: ko.observable(0),
            maxPpsPayout: ko.observable(2500),
            sessionAggregate: ko.observable('us'),
            totalAmount: ko.observable(0),
            totalCommission: ko.observable(0),
            totalPerformance: ko.observable(0),
            totalSessions: ko.observable(0),
            totalUsSessions: ko.observable(0),
            totalPpsCalc: ko.observable(0),
            totalPpsUsCalc: ko.observable(0),
            totalPpsAllCalc: ko.observable(100),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickAdd: function () {
                self.onClickAdd();
            },
            onClickEdit: function (value, data, event) {
                self.onClickEdit(value, data, event);
            },
            onClickDelete: function (value, data, event) {
                self.onClickDelete(value, data, event);
            },
            onEditAmount: function (type, data, event) {
                self.onClickEditAmount(type, data, event);
            },
            onCopyPpsCalcToPerformance: function (data) {
                self.copyPpsCalcToPerformance(data);
            },
            onApplyChanges: function(data, event) {
                self.onApplyChanges();
            },
            onCalculatePayPerSession: function(data, event) {
                self.calculatePayPerSession();
            },
            onClickSessionsAggregate: function (value, data,event){
                self.clickSessionsAggregate();
            },
        };
    }

    public isUsSession() {
        return this.getTemplateViewModel().sessionAggregate() == 'us';
    }

    public buildDatePickerCalendar() {

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest() {

        return {
            list: {
                orderBy: this.getTemplateViewModel().orderBy,
                orderByDirection: this.getTemplateViewModel().orderByDirection,
                orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            },
            filterSimple: this.getTemplateViewModel().filterSimple,
            networkCategory: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
            pagination: this.getTemplateViewModel().pagination
        }
    }

    public activateLoading() {

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading() {

        this.getTemplateViewModel().isLoading(0);
    }

    public setData(data, companyId) {

        this.getTemplateViewModel().editedFieldCount(0);
        let minPayout = this.getTemplateViewModel().minPayout();

        let newList = [];
        for (let item of data) {
            let newObj = {};
            for (let key of Object.keys(item)) {
                if (!isNaN(parseFloat(item[key])) && key != "id" && key != "totalAmount") {

                    newObj[key + "Edited"] = ko.observable(false);
                    newObj["default" + key] = ko.observable(item[key]);
                }
                if (!isNaN(parseFloat(item[key])) && (key == "ppsUsCalc" || key == "ppsAllCalc")) {
                    if (this.isUsSession()) {
                        newObj['ppsCalc'] = ko.observable(parseFloat(item['ppsUsCalc']));
                    } else {
                        newObj['ppsCalc'] = ko.observable(parseFloat(item['ppsAllCalc']));
                    }
                    if (Number(newObj['ppsCalc']()) < Number(minPayout)) {
                        newObj['ppsCalc'] =  ko.observable(0);
                    }
                }
                if (key.includes("total")) {
                    newObj[key] = ko.observable(parseFloat(item[key]));
                } else {
                    newObj[key] = ko.observable(item[key]);
                }
            }
            newObj['disableInput'] = ko.observable(Number(companyId) != Number(item.idCompany));
            newList.push(newObj);
        }

        this.getTemplateViewModel().data(newList);
    }

    public setUsers(users) {

        this.getTemplateViewModel().filterUser.users(users);
    }

    public setArticles(articles) {

        this.getTemplateViewModel().filterArticle.articles(articles);
    }

    public setContentTypes(filterList: Array<{ id: number, name: string }>): void {

        this.filterContentType.setItems(filterList);
    }

    public setZeroColumnFilterItems(filterList: Array<{ id: number, name: string }>) {

        this.zeroColumnsFilter.setItems(filterList);
    }

    public onClickAdd() {

        this.caller.addTransaction();
    }

    public onClickEdit(value, data, event) {

        this.caller.editTransaction(value.id);
    }

    public onClickDelete(value, data, event) {

        this.caller.deleteTransaction(value.id);
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionListReorder();
    }

    protected onUpdateError(requestStatus: any, responseParsed): void {

        let msg = "error: while obtaining the form data - (" + responseParsed.message + ")";
        this.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
    }

    protected onClickEditAmount(type, data, e) {

        var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
        if ((keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode == 91 || keyCode == 93 ) {
            if (type == "commission") {
                if (parseFloat(data.totalCommission()) != parseFloat(data.defaulttotalCommission())) {
                    if (!data.totalCommissionEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalCommissionEdited(true);
                } else {
                    if (data.totalCommissionEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalCommissionEdited(false);
                }
            } else if (type == "performance") {

                if (parseFloat(data.totalPerformance()) != parseFloat(data.defaulttotalPerformance())) {
                    if (!data.totalPerformanceEdited()) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                    }
                    data.totalPerformanceEdited(true);
                } else {
                    if (data.totalPerformanceEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                        this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                    }
                    data.totalPerformanceEdited(false);

                }
            }
        }

        data.totalAmount(parseFloat(data.totalPerformance()) + parseFloat(data.totalCommission()));

        let isUsSession = this.isUsSession();
        let minPayout = this.getTemplateViewModel().minPayout();

        let ppsCalculated = this.calculatePayout(isUsSession ? data.usSessions() : data.sessions(), data.ppsRate(), data.maxPpsPayout(), minPayout);
        data.ppsCalc(ppsCalculated);

    }

    private calculatePayout(sessions, ppsRate, maxPpsPayout, minPayout) {
        // Calculate the rounded value
        const number = Number((sessions * ppsRate) / 1000);
        const calculatedValue =  Number(number.toFixed(2));

        if (Number(calculatedValue) < Number(minPayout)) {
            return 0;
        }

        // Return the minimum of the calculated value and the default max payout
        return Math.min(calculatedValue, maxPpsPayout);
    }

    public copyPpsCalcToPerformance(data){

        if (parseFloat(data.ppsCalc()) > 0 ) {
            data.totalPerformance(data.ppsCalc());
            data.totalAmount(parseFloat(data.totalPerformance()) + parseFloat(data.totalCommission()));
            if (parseFloat(data.totalPerformance()) != parseFloat(data.defaulttotalPerformance())) {
                if (!data.totalPerformanceEdited()) {
                    this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) + 1)
                }
                data.totalPerformanceEdited(true);
            } else {
                if (data.totalPerformanceEdited() && parseInt(this.getTemplateViewModel().editedFieldCount()) > 0) {
                    this.getTemplateViewModel().editedFieldCount(parseInt(this.getTemplateViewModel().editedFieldCount()) - 1)
                }
                data.totalPerformanceEdited(false);
            }
        }
    }

    public calculatePayPerSession() {

        let ppsRate = this.getTemplateViewModel().ppsRate();
        let maxPpsPayout = this.getTemplateViewModel().maxPpsPayout();
        let dataItems = this.getTemplateViewModel().data();
        let isUsSession = this.isUsSession();
        let minPayout = this.getTemplateViewModel().minPayout();
        ko.utils.arrayForEach(dataItems, (item) => {

            item.ppsCalc(this.calculatePayout(isUsSession ? item.usSessions() : item.sessions(), ppsRate, maxPpsPayout, minPayout));
        });

        this.getTemplateViewModel().data(dataItems);
    }

    public clickSessionsAggregate(){
        let data = this.getTemplateViewModel().data();
        let isUsSession = this.isUsSession();
        let minPayout = this.getTemplateViewModel().minPayout();
        for (let item of data) {
            if (isUsSession) {
                item.ppsCalc(item.ppsUsCalc());
            } else {
                item.ppsCalc(item.ppsAllCalc());
            }
            if (Number(item.ppsCalc()) < Number(minPayout)) {
                item.ppsCalc(0);
            }
        }
    }

    public onApplyChanges(){

        let idRole = this.rolesFilter.getTemplateViewModel().selectedOption();
        this.caller.save(idRole, this.getTemplateViewModel().data);
    }

    public setResultInfo(totals, execTime) {

        this.resultsInfos.setExecutionTime(execTime);
        this.resultsInfos.setNbResults(totals.count);
        this.resultsInfos.setNbPages(totals.totalPages);
        this.setTotalAmount(totals.totalAmount);
        this.setTotalCommission(totals.totalCommission);
        this.setTotalPerformance(totals.totalPerformance);
        this.setTotalSessions(totals.totalSessions);
        this.setTotalUsSessions(totals.totalUsSessions);
        this.setTotalPpsCalc(totals.totalPpsCalc);
        this.setTotalPpsUsCalc(totals.totalPpsUsCalc);
        this.setTotalPpsAllCalc(totals.totalPpsAllCalc);
    }


    public setPaymentCategoryFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.paymentCategories});
        }
        this.paymentCategoryFilter.setMultiSectionItems(groups);
    }

    public setTotalAmount(totalAmount) {
        this.getTemplateViewModel().totalAmount(totalAmount);
    }
    public setTotalCommission(totalCommission) {
        this.getTemplateViewModel().totalCommission(totalCommission);
    }
    public setTotalPerformance(totalPerformance) {
        this.getTemplateViewModel().totalPerformance(totalPerformance);
    }
    public setTotalSessions(totalSessions) {
        this.getTemplateViewModel().totalSessions(totalSessions);
    }
    public setTotalUsSessions(totalUsSessions) {
        this.getTemplateViewModel().totalUsSessions(totalUsSessions);
    }
    public setTotalPpsCalc(totalPpsCalc) {
        this.getTemplateViewModel().totalPpsCalc(totalPpsCalc);
    }
    public setTotalPpsUsCalc(totalPpsUsCalc) {
        this.getTemplateViewModel().totalPpsUsCalc(totalPpsUsCalc);
    }
    public setTotalPpsAllCalc(totalPpsAllCalc) {
        this.getTemplateViewModel().totalPpsAllCalc(totalPpsAllCalc);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/transactionsVerificationList_template.ts